import styled from "styled-components";
import { Trans } from "@coworker/locales";

const Warning = styled("div")<{ $centerText: boolean }>`
  font-size: 14px;
  font-weight: normal;
  color: var(--error);
  margin-bottom: 6px;
  text-align: ${({ $centerText }) => ($centerText ? "center" : "left")};
`;

const WarningText = ({
  alternateWarningTranslation,
}: {
  alternateWarningTranslation: string;
}) =>
  !alternateWarningTranslation ? (
    <Trans>pleaseFillInString</Trans>
  ) : (
    <>{alternateWarningTranslation}</>
  );

interface PleaseFillInProps {
  show: boolean;
  alternateWarningTranslation?: string;
  centerText?: boolean;
  testId?: string;
}

export function PleaseFillIn({
  show,
  alternateWarningTranslation = "",
  centerText = false,
  testId,
}: PleaseFillInProps) {
  return show ? (
    <Warning $centerText={!!centerText} data-testid={testId}>
      <WarningText alternateWarningTranslation={alternateWarningTranslation} />
    </Warning>
  ) : (
    <></>
  );
}
